/**
 * Маршрут спирали по квадратной сетке: номер каждой клетки на пути от левого
 * верхнего угла по часовой стрелке к центру. По нему точечный лоадер зажигает
 * точки по очереди — хвост вьётся от края к середине.
 */
export function spiralOrder(n: number): number[] {
  const order = new Array<number>(n * n).fill(-1);
  let top = 0;
  let bottom = n - 1;
  let left = 0;
  let right = n - 1;
  let k = 0;
  while (top <= bottom && left <= right) {
    for (let c = left; c <= right; c++) order[top * n + c] = k++;
    top++;
    for (let r = top; r <= bottom; r++) order[r * n + right] = k++;
    right--;
    if (top <= bottom) {
      for (let c = right; c >= left; c--) order[bottom * n + c] = k++;
      bottom--;
    }
    if (left <= right) {
      for (let r = bottom; r >= top; r--) order[r * n + left] = k++;
      left++;
    }
  }
  return order;
}
